import { PLATFORM_INFO } from '../../types';

interface PlatformBadgeProps {
  platform: string;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

const FALLBACK = { name: 'Unknown', icon: '📱', color: 'bg-gray-500' };

export function PlatformBadge({ platform, size = 'sm', showIcon = true }: PlatformBadgeProps) {
  const info = PLATFORM_INFO[platform] ?? { ...FALLBACK, name: platform };
  const safeColor = info?.color ?? 'bg-gray-500';
  const safeName = info?.name ?? platform;
  const safeIcon = info?.icon ?? '📱';
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium text-white ${safeColor} ${sizeClasses[size]}`}
    >
      {showIcon && <span>{safeIcon}</span>}
      <span>{safeName}</span>
    </span>
  );
}
